import {buildUrl} from '#util/url';

export const getSignOutUrl = (): string => {
  const storeOrigin = process.env.NEXT_PUBLIC_STORE_URL;
  const feOrigin = process.env.NEXT_PUBLIC_FE_URL;

  // The "sign out URL" can technically just be like this:
  // return buildUrl({
  //   origin: storeOrigin,
  //   path: '/pages/logout',
  //   queries: {return_to: buildUrl({origin: feOrigin, path: '/signout'})},
  // });
  // ... however, right now the Shopify store is password protected, and
  // without first entering the store password, the `/page/logout` path is
  // unreachable. If the store's log out page is not reachable, the chain of
  // redirect would be broken and the user would not be redirected back to the
  // app's `/signout` page to finish signing out from the app.
  // That's recomendations, for now, the "sign out URL" is a bit more complex as we want
  // to first sign the user out from the app, then redirect the user to the
  // store to sign the user out from the store, and then redirect the user back
  // to the app's `/signout` page to display the "signed out" view:
  return buildUrl({
    origin: feOrigin,
    path: '/signout',
    queries: {
      return_to: buildUrl({
        origin: storeOrigin,
        path: '/pages/logout',
        queries: {return_to: buildUrl({origin: feOrigin, path: '/signout'})},
      }),
    },
  });
};
